import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useCurrentUser } from "hooks/auth";
import { SharedProfile } from "newui/features/SharedProfile/sharedProfile.type";
import { StaleTime } from "newui/store/tanstack-base";
import { getAllSharedProfilesForCurrentUser } from "../auth-api";
import { ApiResponse } from "types/common.types";

export const useAllSharedProfiles = (): UseQueryResult<
	AxiosResponse<ApiResponse<SharedProfile[]>>
> => {
	const { currentUser } = useCurrentUser();

	return useQuery<AxiosResponse<ApiResponse<SharedProfile[]>>>({
		queryKey: ["shared-profiles-user", currentUser?.id],
		queryFn: () => getAllSharedProfilesForCurrentUser(),
		enabled: !!currentUser?.id,
		staleTime: StaleTime.Short,
	});
};
